import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { TaskState } from '../../../../../../../gql/graphql';
import ErrorBox from 'components/Atoms/Alerts/ErrorBox';
import alertIcon from 'assets/images/alert-triangle.svg';

interface Props {
  fetching: boolean;
  disabled: boolean;
  onClick: any;
  ownerships?: any[];
  ownerState?: TaskState;
  messageErrorDisabled?: string;
}

const ModalSubmitProfile = (props: Props) => {
  const [showErrorBox, setShowErrorBox] = useState(false);

  useEffect(() => {
    if (!props.disabled) setShowErrorBox(false);
  }, [props.disabled])

  return (
    <div style={{ position: 'relative' }}>
      <Button
        className={props.ownerState === TaskState.RequestError ? 'button button-submit button-submit-error' : 'button button-submit'}
        onClick={props.onClick}
        disabled={props.disabled}
        loading={props.fetching}
      >
        {props.ownerState === TaskState.RequestError ?
          <b>Update profile to continue</b> :
          <span>
            Complete guarantor information to continue
          </span>
        }
      </Button>
      {props.disabled && (
        <div
          onClick={() => setShowErrorBox(true)}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            cursor: 'not-allowed',
            backgroundColor: 'transparent'
          }}
        />
      )}
      {showErrorBox && props.messageErrorDisabled && (
        <ErrorBox text={props.messageErrorDisabled} img={alertIcon} className="mt-10" />
      )}
    </div>
  );
};
export default ModalSubmitProfile;
